import { useId, type ReactNode } from 'react';
import './switch-row.css';

/** Общая строка-переключатель из шаблона BotCore.switchRow. */
export function SwitchRow({
  title,
  description,
  icon,
  checked,
  disabled = false,
  onChange,
}: {
  title: string;
  description: string;
  icon: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange(checked: boolean): void;
}) {
  const id = useId();
  return (
    <button
      type="button"
      className={`ap-cheap studio-switch-row${checked ? ' on' : ''}`}
      role="switch"
      aria-checked={checked}
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-description`}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="ic" aria-hidden="true">
        {icon}
      </span>
      <span className="m">
        <b id={`${id}-title`}>{title}</b>
        <span id={`${id}-description`}>{description}</span>
      </span>
      <span className={`sw${checked ? ' on' : ''}`} aria-hidden="true" />
    </button>
  );
}
